import Store from 'store/store';
import { addClass, removeClass, accessNested } from 'utils/utils';
import { smoothScrollTo } from 'utils/smoothScroll';
import { getMainPage } from 'utils/bolt';

let showtimesShowing = false;
let homeEntShowing = false;

Store.on('SWITCH_DUAL_VIEW', (page, isWidget) => {
	if (isWidget) {
		return;
	}

	const isShowtimes = page === 'showtimes';

	window.setTimeout(() => {
		closeSidePanel(false, false, isShowtimes ? 'homeEnt' : 'showtimes');
		showtimesShowing = isShowtimes;
		homeEntShowing = !isShowtimes;
		Store.emit('SET_ACTIVE_PAGE', isShowtimes ? 'boltShowtimes' : 'boltHomeEnt');
	}, 300);
	openSidePanel(false, isShowtimes ? 'showtimes' : 'homeEnt', true);
});

export const openSidePanel = (animate, comp, disableCloseAllOverlays, queryString, pageId) => {
	const isShowtimes = comp === 'showtimes';
	const isHomeEnt = comp === 'homeEnt';

	if (isShowtimes && showtimesShowing) return;
	if (isHomeEnt && homeEntShowing) return;

	if (!disableCloseAllOverlays) {
		Store.emit('CLOSE_ALL_OVERLAYS');
	}

	Store.get().set({ ignoreScroll: true });

	if (isShowtimes) showtimesShowing = true;
	if (isHomeEnt) homeEntShowing = true;

	const scroller = document.getElementById('mainScroll');

	const show = () => {

		if (isShowtimes) {
			Store.get().header.set({ showtimesOverlay: true });
			Store.get().showtimes.set({ show: pageId || true, animate });
			if (Store.get().showtimes.providerInterstitialOpen) {
				const actionData = {
					icon: 'back',
					action: () => Store.emit('CLOSE_PROVIDER_INTERSTITIAL')
				};
				const isDesktopSize = Store.get().client.isDesktopSize;
				isDesktopSize ? Store.emit('SET_SHOWTIMES_BTN_ACTIONS', actionData) : Store.emit('SET_HEADER_ACTION', actionData);
			}
			if (!showtimesShowing) return;
		}

		if (isHomeEnt) {
			Store.get().header.set({ homeEntOverlay: true });
			Store.get().homeEnt.set({ show: pageId || true, animate });
			if (!homeEntShowing) return;
		}

		Store.get().set({ ignoreScroll: false });
		Store.emit('UPDATE_VISIBILITY_PERCENTAGES');

		if (isShowtimes) {
			Store.emit('SET_ACTIVE_PAGE', pageId || 'boltShowtimes', queryString);
		} else if (isHomeEnt) {
			Store.emit('SET_ACTIVE_PAGE', pageId || 'boltHomeEnt', queryString);
		}

		addClass(document.body, 'locked');
		if (scroller) {
			setTimeout(() => {
				removeClass(scroller, 'nonInteractive');
			}, 500);
		}
	};

	if (scroller) {
		addClass(scroller, 'nonInteractive');
		smoothScrollTo(scroller, 0, !animate ? 0 : dist => Math.min(dist / 3, 200), {
			force: true,
			callback: show
		});
	} else {
		show();
	}
};


export const closeSidePanel = (animate, updateActivePage = true, comp) => {
	const isShowtimes = comp === 'showtimes';
	const isHomeEnt = comp === 'homeEnt';

	if (isShowtimes && !showtimesShowing) return;
	if (isHomeEnt && !homeEntShowing) return;

	const shareOpen = accessNested(Store.get(), 'header.shareOpen');
	if (shareOpen) {
		return;
	}

	if (isShowtimes) {
		showtimesShowing = false;
		Store.get().header.set({ showtimesOverlay: false });
		Store.get().showtimes.set({ show: false, animate });
		Store.emit('EXIT_CINEMA_DETAIL_VIEW');
		Store.emit('CLOSE_PROVIDER_INTERSTITIAL');
	}

	if (isHomeEnt) {
		homeEntShowing = false;
		Store.get().header.set({ homeEntOverlay: false });
		Store.get().homeEnt.set({ show: false, animate });
	}


	if (updateActivePage) {
		Store.emit('SET_ACTIVE_PAGE', getMainPage());
		Store.emit('CHANGE_ACTIVE_SECTION', getMainPage(), { instant: true });
	}

	removeClass(document.body, 'locked');
};
